import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Rules from './Rules';
import { useAppContext } from './AppContext';
import { LoginData } from './types';

const Welcome: React.FC = () => {
  const { loginData, dataIsReady } = useAppContext();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
        
  }, [loginData]);

  if (!dataIsReady) {
    return <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      title="Loading"
      content={<div>Getting points...</div>}
      buttonText="Close"
    />;
  }

  if (!loginData) {
    return (
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={"Sorry!"}
        content={'Error fetching data.'}
        buttonText="Close"
      />
    );
  } else if (loginData.firstTime) {
    return (
      <Rules onClose={() => {}}/>
    );
  } else {
    return (
      <div className="popup">
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={"You know, we missed you, pal. Welcome back!"}
          //imageSrc={WelcomeImg}
          content={<WelcomeData loginData={loginData}/>}
          buttonText="Close"
        />
      </div>
    );
  }  
};

const WelcomeData: React.FC<{ loginData: LoginData }> = ({ loginData }) => {
  return (<div className='flex flex-col gap-4'>
    <div className="bg-white p-4 rounded-2xl border-2 border-black shadow-lg">
      <div className='flex flex-col text-center'>
        {loginData.daysInactive > 0 ? <>
          <p>Days inactive: {loginData.daysInactive}</p>
          <p>Highest FM: x{parseFloat((loginData.highestMultiplier).toFixed(2))}</p>
          <p>NAP earned: {parseFloat((loginData.pointsEarned).toFixed(2))}</p>
        </> : 
        <p>You've already collected points today. Come back as late as possible!</p>}
      </div>
    </div> 
    <p className='text-center'>Farm multiplier has been reset to Base FM (x{parseFloat((loginData.baseMultiplier).toFixed(2))}). Get some rest now.</p>          
  </div>)
}

export default Welcome;